export default __webpack_public_path__ + "static/media/UZ.3591058c.svg";